module.exports = __webpack_public_path__ + "img/noise-detect-example.2072785e.png";